import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import RecordRTC from "recordrtc";
import propTypes from "prop-types";
import firebase from "firebase/app";
import "firebase/database";
import * as moment from "moment";
import "moment/locale/fr";
import axios from "axios";

import { captureUserMedia } from "../Utils/helpers";
import ValidBrowser from "../Utils/ValidBrowser";
import { testValidBrowser } from "../Utils/helpers";

import Webcam from "../Components/Webcam.jsx";
import SpeechInfo from "../Components/SpeechInfo.jsx";
import Button from "../Components/Button/Button.base.jsx";
import CountDown from "../Components/Countdown.jsx";
import Notifier from "../Components/Notifier.jsx";

class Recorder extends Component {
  constructor(props) {
    super(props);
    this.recordVideo = null;
    this.videoRef = React.createRef();
    this.state = {
      isRecording: false,
      uploadFail: null,
      uploading: false,
      isCountDownBeforeStartActive: false,
      isCountDownDuringRecordActive: false,
      pitchTitle: "",
      pitchDescription: ""
    };
  }

  componentDidMount = () => {
    captureUserMedia((stream) => {
      this.videoRef.current.srcObject = stream;
      this.recordVideo = RecordRTC(stream, { type: "video" });
    });
  };

  componentWillUnmount = () => {
    this.stopRecord();
  }

  handleChangeTitle = (event) => {
    this.setState({ pitchTitle: event.target.value });
  };

  handleChangeDescription = (event) => {
    this.setState({ pitchDescription: event.target.value });
  };

  sendNotifToAdmin = (pitchId) => {
    axios({
      method: "post",
      url: process.env.REACT_APP_BASE_URL + 'send/email/',
      data: {
        notif: "New pitch",
        pitchOwner: this.props.user.displayName,
        pitchOwnerEmail: this.props.user.email,
        pitchTitle: this.state.pitchTitle,
        pitchId: pitchId,
      }
    })
      .then((response) => {
        console.log("email successfully send to admin");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  uploadRecord = () => {
    this.recordVideo.stopRecording(() => {
      let filename = Date.now();
      let file = new File(
        [this.recordVideo.blob], 
        filename + ".webm", 
        {type: "video/webm;codecs=h264"}
      );

      let config = {
        name: file.name,
        file: file,
        contentType: "video/webm",
        progress: () => {
          // eslint-disable-next-line
          null;
        },
        complete: (_xhr) => {
          // eslint-disable-next-line
          null;
        }
      };

      this.setState({
        uploading: true,
        isRecording: false
      });

      // TODO: 
      // Implémenter ici la création et l'upload du thumbnail ou le faire directement dans AWS
      this.props.upload(config).then(
        (success) => {
          if (success) {
            firebase
              .database()
              .ref(`videos/${filename}`)
              .set({
                transcodedUrl: `https://s3.amazonaws.com/m4p-export/${filename}/${filename}-web-720p.mp4`,
                // thumbnail: `https://s3.amazonaws.com/m4p-export/${filename}/${filename}-thumb.png`,
                title: this.state.pitchTitle,
                description: this.state.pitchDescription,
                userId: this.props.user.uid,
                userName: this.props.user.displayName,
                userAvatar: this.props.user.photoURL,
                userMail: this.props.user.email,
                createdAt: moment().format("DD/MM/YYYY HH:mm")
              })
              .then((res) => {
                this.sendNotifToAdmin(filename);

                this.setState({uploading: false });
                this.props.history.push("/uploading");

                return res;
              })
              .catch((error) => {
                console.error(error);
                return error;
              })
            ;
          }
        },
        (error) => {
          this.setState({ uploadFail: true, uploading: false });
          console.error(error);
        }
      );
    });
  };

  startRecord = () => {
    this.recordVideo.startRecording();
  };

  stopRecord = () => {
    if (this.isRecording && this.recordVideo.isRecording) {
      this.recordVideo.stopRecording();
    }
    this.videoRef.current.srcObject.getTracks().forEach((track) => {
      track.stop();
    });
  };

  handleButtonStart = () => {
    this.setState({ isCountDownBeforeStartActive: true });
  };

  handleButtonStop = () => {
    this.setState(
      {
        isCountDownBeforeStartActive: false,
        isCountDownDuringRecordActive: false,
        isRecording: false
      },
      () => {
        this.stopRecord();
        this.uploadRecord();
      }
    );
  };
  handleButtonCancel = () => {
    this.setState(
      {
        isCountDownBeforeStartActive: false,
        isCountDownDuringRecordActive: false,
        isRecording: false
      },
      () => {
        this.stopRecord();
        window.location.reload();
      }
    );
  };

  handleCountDownBeforeStartFinish = () => {
    this.setState(
      {
        isCountDownBeforeStartActive: false,
        isCountDownDuringRecordActive: true,
        isRecording: true
      },
      () => {
        this.startRecord();
      }
    );
  };

  handleCountDownDuringRecordFinish = () => {
    this.setState(
      { isCountDownDuringRecordActive: false, isRecording: false },
      () => {
        this.uploadRecord();
      }
    );
  };

  render() {
    return (
      <ValidBrowser
        test={testValidBrowser}
        valid={
          <div>
            <SpeechInfo
              titleValue={this.state.pitchTitle}
              onTitleChange={(event) => this.handleChangeTitle(event)}
              descriptionValue={this.state.pitchDescription}
              onDescriptionChange={(event) =>
                this.handleChangeDescription(event)
              }
            />

            <div>
            <Webcam srcObjectRef={this.videoRef} />
              {/* {
                this.state.isReadyToPlayBeforeSave
                ? <video src={localStorage.getItem('localStreamFile')} type="video/webm" />
                : <Webcam srcObjectRef={this.videoRef} />
              } */}
              
            </div>

            {/* {
              this.state.uploading 
              ? (
                <Notifier type="info" message="Uploading ..." />
              ) 
              : null
            }

            {
              this.state.uploadSuccess 
              ? (
                <Notifier
                  type="success"
                  message="`Votre pitch à été uploadé avec succès. Vous allez être redirigé vers la page d'évaluation !"
                />
              ) 
              : null
            } */}

            {
              this.state.uploadFail 
              ? (
                <Notifier
                  type="error"
                  message="Erreur d'upload, vérifiez votre connexion et réessayez !"
                />
              )
              : null
            }

            <div>
              {
                this.state.isRecording ||
                this.state.isCountDownBeforeStartActive 
                ? (
                  <div>
                    <Button label="Annuler" onClick={this.handleButtonCancel} />
                    {
                      this.state.isRecording && (
                        <Button label="Stop" onClick={this.handleButtonStop} />
                      )
                    }
                  </div>
                ) 
                : this.state.pitchTitle &&
                  this.state.pitchDescription &&
                  this.state.uploading === false 
                  ? (
                    <Button label="Démarrer" onClick={this.handleButtonStart} />
                  ) 
                  : (
                    <Button
                      label="Démarrer"
                      onClick={this.handleButtonStart}
                      disabled
                    />
                  )
              }

              {
                this.state.isCountDownBeforeStartActive
                && (
                  <CountDown
                    className="countdown-before"
                    seconds={5}
                    onFinish={this.handleCountDownBeforeStartFinish}
                  />
                )
              }
            </div>

            <div>
              {
                this.state.isCountDownDuringRecordActive 
                && (
                  <CountDown
                    className="countdown-after"
                    onFinish={this.handleCountDownDuringRecordFinish}
                    seconds={90}
                  />
                )
              }
            </div>
          </div>
        }
        error={
          <Notifier
            type="error"
            message="Cette fonctionalité n'est pour l'instant disponible uniquement sur Chome desktop."
          />
        }
      />
    );
  }
}

Recorder.propTypes = {
  upload: propTypes.func.isRequired,
  user: propTypes.object.isRequired
};

export default withRouter(Recorder);
